<template>
    <div>
        <div class="wrapper-category" id="cateEl">
            <div class="wrapper-slider">
                <div class="category-item"
                        v-for="(subCateList, k) in cateList"
                        :key="k"
                        :class="{'active': selectCategory == subCateList}"
                        v-on:click="clickCategory(subCateList)">
                        {{locale == 1054 ? subCateList.name_th : subCateList.name_en}}
                </div>
            </div>
        </div>
        <!-- <carousel id="owl-category"
                :lazyLoad="true"
                :loop="false"
                :autoplay="false"
                :nav="false"
                :dots="false"
                :autoWidth="true"
                :stagePadding="30"
                :startPosition="startPosition"
                v-if="isHaveCategory"
            >
                <div class="category-item"
                    v-for="(subCateList, k) in cateList"
                    :key="k"
                    :class="{'active': selectCategory == subCateList}"
                    v-on:click="clickCategory(subCateList)">
                    {{locale == 1054 ? subCateList.name_th : subCateList.name_en}}
                    </div>
            </carousel> -->
    </div>
</template>
<script>
import Vue from "vue";
//helper
import Locale from "@/helper/locale/locale.js";
import Account from "@/helper/AccountHelper.js";
import DateTime from "@/helper/DatetimeHelper.js";

import { CategoryConfigBuilder } from "@/service/config/CategoryConfigModel.js";
//service
import BzbsCampaign from "@/service/BzbsCampaign.js";


// import Carousel from "vue-owl-carousel";

export default {
    name: "CategoryMenu",
    components: {
        //Carousel
    },
    props: {
        locale: Number,
        strConfig: String,
        selectCateId: String,
        busEven: Object
    },
    data: function() {
        return {
            localeCode: Locale.getLocale().code,
            isLoaded: false,
            isHaveCategory: false,
            cateList: [],
            startPosition: 0,
            configCarousel: {
                responsive: {
                    0: {
                        items: 3,
                        nav: false
                    }
                }
            },
            selectCategory: {},
        };
    },
    created: function() {
        this.initialCategory(this.strConfig);
    },
    mounted: function() {
        this.busEven.$on("reinitCategory", () => {
            this.isLoaded = false;
            this.isHaveCategory= false;
            this.reinitCategory();
            // this.initialCategory(this.strConfig);
            // this.clickCategory(this.cateList[0]);
            // this.startPosition = 0;
        });
    },
    methods: {
        initialCategory: function(strConfig) {
            this.cateList = [];
            var token = Account.getToken();
            var configBuilder = new CategoryConfigBuilder();
            var params = configBuilder
                .setConfig(strConfig)
                .setLocale(this.locale);

            BzbsCampaign.apiGetCategory(token, params.categoryConfig)
                .then(result => {
                    this.setupCategory(result);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        setupCategory: function(cateResult) {
            if (cateResult && cateResult.length > 0) {
                for (var i = 0; i < cateResult.length; i++) {
                    this.cateList.push(cateResult[i]);
                    if (this.selectCateId == cateResult[i].id) {
                        this.selectCategory = cateResult[i];
                        this.startPosition = i;

                    }

                }
                Account.setCacheCustom('categoryId',this.selectCategory.id);
                this.isLoaded = true;
                this.isHaveCategory = true;
                this.setupPostition(this.startPosition);
            }
        },
        setupPostition: function(index) {
            setTimeout(function(){
                var selectCategoryItem = document.getElementsByClassName("category-item")[index];
                var widthDisplay = screen.width;
                if (widthDisplay < (selectCategoryItem.offsetLeft + selectCategoryItem.offsetWidth)) {
                    document.getElementById('cateEl').scrollLeft = (selectCategoryItem.offsetLeft + selectCategoryItem.offsetWidth) - widthDisplay;
                }
            }, 300);
        },
        reinitCategory: function() {
            this.cateList = [];
            var token = Account.getToken();
            var configBuilder = new CategoryConfigBuilder();
            var params = configBuilder
                .setConfig(this.strConfig)
                .setLocale(this.locale);

            BzbsCampaign.apiGetCategory(token, params.categoryConfig)
                .then(result => {
                    this.resetupCategory(result);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        resetupCategory: function(cateResult) {
            if (cateResult && cateResult.length > 0) {
                for (var i = 0; i < cateResult.length; i++) {
                    this.cateList.push(cateResult[i]);
                }
                this.selectCategory = this.cateList[0];
                this.startPosition = 0;
                Account.setCacheCustom('categoryId',this.selectCategory.id);
                this.isLoaded = true;
                this.isHaveCategory = true;
                this.setupPostition(this.startPosition);
            }
        },
        clickCategory: function(objCategory) {
            if (this.selectCategory == objCategory)
                return;
            else
                this.selectCategory = objCategory

            Account.setCacheCustom('categoryId',this.selectCategory.id);

            var gtm = {
                 "event_label": this.selectCategory.name,
                 "timestamp": DateTime.getDateTimeGTM()
            };

            Vue.ga.event(this, "privilege", "click_privilege_category", gtm.event_label, null, gtm);

            this.busEven.$emit('clickcategory', this.selectCategory);
        },
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";


.wrapper-category {
    width: 100vw;
    overflow-x: scroll;

    .wrapper-slider {
        display: flex;
    }
}

.wrappe-category::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.wrappe-category {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

.category-item {
    display: inline-block;
    white-space: nowrap;
    font-size: 22px;
    font-weight: 500;
    text-align: center;
    padding: 0 20px;
    color: $gray-color;

    &.active {
        border-bottom: 3px solid $primery-color;
        color: $primery-color;
        font-weight: 500;
    }
}
// .category-item {
//     // font-size: 1.2em;
//     font-size: 22px;
//     font-weight: 500;
//     // font-weight: bold;
//     text-align: center;
//     padding: 0 20px;
//     color: $gray-color;
//     // border-bottom: 1px solid $gray-color;

//     &.active {
//         border-bottom: 3px solid $primery-color;
//         color: $primery-color;
//         font-weight: 500;
//     }
// }

</style>
<style lang="scss">
@import "@/style/base/common.scss";
// #owl-category{
//     border-bottom: 1px solid $gray-color;
//     .owl-stage {
//         padding-left: 0px !important;
//     }
// }
</style>
